// Builds the (small) context sent to Groq for the FINAL answer-formatting
// step. This intentionally contains NO raw dataset rows — only a schema
// summary — so the full dataset never leaves the browser. All real
// calculations happen locally in the analytics engine before this runs.
export function buildAnswerContext(schema) {

  if (!schema?.columns?.length) {
    return "No dataset schema available.";
  }

  return `
Dataset Information (schema only — no rows)

Columns: ${schema.columns.join(", ")}
Measures (numeric): ${schema.measures.join(", ") || "none detected"}
Dimensions (categorical): ${schema.dimensions.join(", ") || "none detected"}
Time columns: ${schema.time.join(", ") || "none detected"}
`;

}
